import React, { useContext } from 'react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { StepperContext } from 'app/design-system/components/Stepper/context';
import { useFeatureFlag } from 'app/lib/feature-flags';

import { FirstStepForm } from './forms/FirstStepForm';
import { SecondStepForm } from './forms/SecondStepForm';
import { ThirdStepForm, ThirdStepFormWithFP } from './forms/ThirdStepForm';

export const SignBody = () => {
  const { activeStep: registrationStep } = useContext(StepperContext);
  const isFingerprint = useFeatureFlag(FeatureFlag.FINGERPRINT);

  switch (registrationStep) {
    case 1:
      return (
        <FirstStepForm />
      );
    case 2:
      return (
        <SecondStepForm />
      );
    case 3:
      return (
        isFingerprint ? <ThirdStepFormWithFP /> : <ThirdStepForm />
      );
    default:
      return (
        <FirstStepForm />
      );
  }
};
